//Base URL
export const BASE_URL =
  "https://whitelabelnft-user-microservice-120551421124.asia-south2.run.app/";
export const BASE_URL1 =
  "https://whitelabelnft-clientconfig-microservice-120551421124.asia-south2.run.app/";
  export const BASE_URL2 =
  "https://whitelabelnft-content-microservice-120551421124.asia-south2.run.app/";
  export const BASE_URL3 =
  "https://whitelabelnft-clientconfig-microservice-120551421124.asia-south2.run.app/";

  // https://whitelabelnft-clientconfig-microservice-120551421124.asia-south2.run.app/

export const WEB_APP_USER_WALLET_ADDRESS = "WEB_APP_USER_WALLET_ADDRESS";
export const ADD_WALLET = "ADD_WALLET";
export const LOGGED_IN_UER_DETAILS = "LOGGED_IN_UER_DETAILS";
export const NFTSData = "NFTSData";
export const ADD_WALLET_ADDRESS = "ADD_WALLET_ADDRESS"
export const tenantLogin="tenantLogin"
export const SubscriptionMonthlyData="SubscriptionMonthlyData";
export const SubscriptionYearlyData="SubscriptionYearlyData";
export const Home_NFT="Home_NFT";
export const User_Token="token"

export const GET_ERRORS = "GET_ERRORS";
export const ALL_USERS = "ALL_USERS";
export const OPEN_NOTIFICATION = "OPEN_NOTIFICATION";
export const REDIRECT_URL="REDIRECT_URL"
export const OPEN_WALLET = "OPEN_WALLET";
export const WHITE_LABEL_TOKEN="WHITE_LABEL_TOKEN"
export const SEARCH_FROM_NAV="SEARCH_FROM_NAV"
export const LOG_OUT = "LOG_OUT";
export const ADD_USER = "ADD_USER"; // --- WE ARE NOT USING THIS
